import React, { useState } from 'react';

const SOURCE_TYPES = [
  'Family record',
  'Birth or marriage record',
  'Archive',
  'Newspaper',
  'Book',
  'Website',
  'Other',
];

export default function FamilyTreeCitationEditor({ citation, saving, onCancel, onSave }) {
  const [title, setTitle] = useState(citation?.source_title ?? '');
  const [url, setUrl] = useState(citation?.source_url ?? '');
  const [type, setType] = useState(citation?.source_type ?? 'Family record');
  const [note, setNote] = useState(citation?.citation_note ?? '');

  const submit = (event) => {
    event.preventDefault();
    onSave({
      source_title: title.trim(),
      source_url: url.trim() || null,
      source_type: type,
      citation_note: note.trim() || null,
    });
  };

  return (
    <form onSubmit={submit} className="space-y-2.5 rounded-xl border border-brand-dark bg-brand-light/50 p-3">
      <label className="block text-[9px] font-black uppercase tracking-widest text-text-muted">
        Source title
        <input
          required
          maxLength={255}
          value={title}
          onChange={event => setTitle(event.target.value)}
          placeholder="e.g. 1942 birth certificate"
          className="mt-1 w-full rounded-lg border border-brand-dark bg-white px-3 py-2 text-xs font-medium normal-case tracking-normal text-accent-navy outline-none focus:border-accent-gold"
        />
      </label>
      <label className="block text-[9px] font-black uppercase tracking-widest text-text-muted">
        Source type
        <select
          value={type}
          onChange={event => setType(event.target.value)}
          className="mt-1 w-full rounded-lg border border-brand-dark bg-white px-3 py-2 text-xs font-medium normal-case tracking-normal text-accent-navy outline-none focus:border-accent-gold"
        >
          {SOURCE_TYPES.map(sourceType => (
            <option key={sourceType} value={sourceType}>{sourceType}</option>
          ))}
        </select>
      </label>
      <label className="block text-[9px] font-black uppercase tracking-widest text-text-muted">
        Source link
        <input
          type="url"
          maxLength={2048}
          value={url}
          onChange={event => setUrl(event.target.value)}
          placeholder="https://..."
          className="mt-1 w-full rounded-lg border border-brand-dark bg-white px-3 py-2 text-xs font-medium normal-case tracking-normal text-accent-navy outline-none focus:border-accent-gold"
        />
      </label>
      <label className="block text-[9px] font-black uppercase tracking-widest text-text-muted">
        Research note
        <textarea
          rows={2}
          maxLength={1000}
          value={note}
          onChange={event => setNote(event.target.value)}
          placeholder="Page number, archive, or detail that supports this record"
          className="mt-1 w-full resize-y rounded-lg border border-brand-dark bg-white px-3 py-2 text-xs font-medium normal-case tracking-normal text-accent-navy outline-none focus:border-accent-gold"
        />
      </label>
      <div className="flex gap-2 pt-1">
        <button
          type="submit"
          disabled={saving || !title.trim()}
          className="flex-1 rounded-lg bg-accent-navy px-3 py-2 text-[9px] font-black uppercase tracking-widest text-white transition-colors hover:bg-accent-gold disabled:cursor-not-allowed disabled:opacity-50"
        >
          {saving ? 'Saving…' : citation ? 'Save changes' : 'Add citation'}
        </button>
        <button
          type="button"
          onClick={onCancel}
          disabled={saving}
          className="rounded-lg border border-brand-dark bg-white px-3 py-2 text-[9px] font-black uppercase tracking-widest text-text-muted transition-colors hover:text-accent-navy"
        >
          Cancel
        </button>
      </div>
    </form>
  );
}